import React, {useMemo} from 'react';
import type {RightPanelConfig} from 'components/scene/types';
import {isFeatureEnabled} from 'configuration';
import {CodeListsGate} from 'services/codelists';
import {useAllCodeListIds} from 'services/codelists/hooks/useAllCodeListIds';
import {ThesaurusesGate} from 'services/thesaurus';
import {useAllThesaurusIds} from 'services/thesaurus/hooks/useAllThesaurusIds';
import {
  SceneExtensionsContext,
  useLinkedValueSearchSceneExtensionCore,
  useSceneExtensionsContextProviderValue,
} from 'sceneExtensions';
import {SearchAgentsScene} from './SearchAgentsScene';

export const AgentsScene: React.FC = () => {
  const thesaurusIds = useAllThesaurusIds();
  const searchConfig: Partial<RightPanelConfig> = {
    initialFullWidth: !isFeatureEnabled('norafChanges'),
    canToggleFullWidth: true,
  };

  const codelistIds = useAllCodeListIds();

  const linkedValueSearchExtension =
    useLinkedValueSearchSceneExtensionCore(searchConfig);
  const extensions = useMemo(
    () => [linkedValueSearchExtension],
    [linkedValueSearchExtension],
  );

  const sceneExtensionContext =
    useSceneExtensionsContextProviderValue(extensions);

  return (
    <ThesaurusesGate thesauruses={thesaurusIds}>
      <CodeListsGate codeLists={codelistIds}>
        <SceneExtensionsContext.Provider value={sceneExtensionContext}>
          <SearchAgentsScene />
        </SceneExtensionsContext.Provider>
      </CodeListsGate>
    </ThesaurusesGate>
  );
};
